import { Base } from 'src/api/Base'

export class DealerAPI extends Base {
  static get entity() {
    return 'dealer'
  }

  async update(body) {
    const { data } = await this.request().post(`/${this.entity}/update`, body)

    return data
  }

  static async getList() {
    const { data } = await this.request().get(`/${this.entity}/list`)

    return data
  }

  static async getFullList() {
    const { data } = await this.request().get(`/${this.entity}/full-list`)

    return data
  }
}
